/* tslint:disable */
/* eslint-disable */
/**
 * Assemblean Production Solutions
 * Produce the lean way with APCS
 *
 * The version of the OpenAPI document: 0.9.0
 * 
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */

import { mapValues } from '../runtime';
import type { APIGuestRequest } from './APIGuestRequest';
import {
    APIGuestRequestFromJSON,
    APIGuestRequestFromJSONTyped,
    APIGuestRequestToJSON,
} from './APIGuestRequest';

/**
 * 
 * @export
 * @interface APIPaginatedGuestRequestList
 */
export interface APIPaginatedGuestRequestList {
    /**
     * 
     * @type {number}
     * @memberof APIPaginatedGuestRequestList
     */
    count: number;
    /**
     * 
     * @type {string}
     * @memberof APIPaginatedGuestRequestList
     */
    next?: string | null;
    /**
     * 
     * @type {string}
     * @memberof APIPaginatedGuestRequestList
     */
    previous?: string | null;
    /**
     * 
     * @type {Array<APIGuestRequest>}
     * @memberof APIPaginatedGuestRequestList
     */
    results: Array<APIGuestRequest>;
}

/**
 * Check if a given object implements the APIPaginatedGuestRequestList interface.
 */
export function instanceOfAPIPaginatedGuestRequestList(value: object): value is APIPaginatedGuestRequestList {
    if (!('count' in value) || value['count'] === undefined) return false;
    if (!('results' in value) || value['results'] === undefined) return false;
    return true;
}

export function APIPaginatedGuestRequestListFromJSON(json: any): APIPaginatedGuestRequestList {
    return APIPaginatedGuestRequestListFromJSONTyped(json, false);
}

export function APIPaginatedGuestRequestListFromJSONTyped(json: any, ignoreDiscriminator: boolean): APIPaginatedGuestRequestList {
    if (json == null) {
        return json;
    }
    return {
        
        'count': json['count'],
        'next': json['next'] == null ? undefined : json['next'],
        'previous': json['previous'] == null ? undefined : json['previous'],
        'results': ((json['results'] as Array<any>).map(APIGuestRequestFromJSON)),
    };
}

export function APIPaginatedGuestRequestListToJSON(value?: APIPaginatedGuestRequestList | null): any {
    if (value == null) {
        return value;
    }
    return {
        
        'count': value['count'],
        'next': value['next'],
        'previous': value['previous'],
        'results': ((value['results'] as Array<any>).map(APIGuestRequestToJSON)),
    };
}

